import { imgUrl } from './imgUrl';

export const encUrl = (path) => {
  const enc = path
    .replace('/images-optimized/', '/images-encrypted/')
    .replace(/\.(jpe?g|png)$/i, '.enc');
  return imgUrl(enc);
};
